import { observer } from 'mobx-react-lite';

import type { GeoLoadSection } from '../../entities/geological-load/geo-load-section.entity';
import type { GeologicalLoadValidation } from '../../entities/geological-load/geological-load-validation';
import { GeologicalItem } from '../geological-load-item';
import type { GeologicalLoadViewModel } from '../geological-load-view-model';

type Props = {
  geoLoadSection: GeoLoadSection;
  viewModel: GeologicalLoadViewModel;
  validation: GeologicalLoadValidation;
  onValueChange(fieldId: string, value: unknown, geoLoadSection: GeoLoadSection): void;
};

export const GeologicalLoadSection = observer<Props>(function GeologicalLoadSection({
  geoLoadSection,
  viewModel,
  validation,
  onValueChange,
}) {
  const { geologicalLoad } = geoLoadSection;

  return (
    <GeologicalItem
      geologicalLoad={geologicalLoad}
      viewModel={viewModel}
      validation={validation}
      onValueChange={(fieldId, value) => onValueChange(fieldId, value, geoLoadSection)}
    />
  );
});
